import "./App.scss";
// import  "dis/bootstrap/less/bootstrap.less";
import React from "react";
import AuthGuard from "guards/AuthGuard";
import { captureAffiliateToken } from "utils/affiliateAttribution";
import { AppProvider } from "./contexts/AppContext";
import SecurityPopup from "elements/SecurityPopup";
import GeoRestriction from "elements/GeoRestriction";
import { Provider } from "react-redux";
import store from "./store";
import api from "services/api";
import { resolveGeoCountry } from "services/requestCountry";

function App(props) {
  const authResult = new URLSearchParams(window.location.search);
  const afftoken = authResult.get("btag");
  React.useEffect(() => {
    captureAffiliateToken(afftoken);
  }, [afftoken]);

  // Resolve the visitor's country once (geo-IP, cached) so subsequent API
  // requests carry X-Request-Country and receive per-country content variants.
  React.useEffect(() => {
    resolveGeoCountry(api);
  }, []);

  return (
    <Provider store={store}>
      <AppProvider>
        <GeoRestriction>
          <SecurityPopup>
            <AuthGuard {...props}></AuthGuard>
          </SecurityPopup>
        </GeoRestriction>
      </AppProvider>
    </Provider>
  );
}

export default App;
